/**
 * General Settings Tab
 */

import React from 'react';
import { Globe, DollarSign } from 'lucide-react';
import { useLanguage } from '../../../i18n';

const GeneralTab: React.FC = () => {
  const { t, language, setLanguage } = useLanguage();

  return (
    <div className="space-y-6">
      {/* Language Setting */}
      <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
        <div className="flex items-center gap-3">
          <Globe className="w-5 h-5 text-slate-600" />
          <div>
            <div className="font-medium text-slate-800">{t.settings.language}</div>
            <div className="text-sm text-slate-500">{t.settings.selectLanguage}</div>
          </div>
        </div>
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value as 'tr' | 'en')}
          className="px-3 py-2 border border-slate-300 rounded-lg text-sm"
        >
          <option value="tr">Türkçe</option>
          <option value="en">English</option>
        </select>
      </div>

      {/* Default Currency Setting */}
      <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
        <div className="flex items-center gap-3">
          <DollarSign className="w-5 h-5 text-slate-600" />
          <div>
            <div className="font-medium text-slate-800">{t.settings.defaultCurrency}</div>
            <div className="text-sm text-slate-500">{t.settings.calculationsInUsd}</div>
          </div>
        </div>
        <div className="px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm font-medium">
          USD ($)
        </div>
      </div>
    </div>
  );
};

export default GeneralTab;
